import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import SentimentByTopicColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/CumulativeSentimentByTopicColumnChart';
import KeywordCountBySentimentTypeColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/KeywordCountBySentimentTypeColumnChart';
import SentimentByTaxonomyStackedColumnChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/SentimentByTaxonomyStackedColumnChart';
import SentimentDonutAndColumnCharts from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/SentimentDonutAndColumnCharts';
import SentimentWeeklyReviewVolumeStackedChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSentiment/Visualizations/SentimentWeeklyReviewVolumeStackedChart';
import ReviewSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryProductGrid';
import { useReviewCumulativeValues } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { EntityNoDataPlaceHolder } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import {
  BEACON_CHART_SPACING,
  BEACON_KEY_METRIC_CARD_SPACING
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity, useSubcategoryEntity } from 'src/utils/Hooks/reduxSelectors';

const ReviewSentimentPage = () => {
  const { reviewCumulativeCountData, reviewCumulativeCountLoading } = useReviewCumulativeValues({
    aggregationFieldNames: ['lifetimeReviewVolume']
  });
  const { isProductEntity } = useProductEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();
  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {!reviewCumulativeCountLoading && reviewCumulativeCountData?.length === 0 ? (
          EntityNoDataPlaceHolder
        ) : (
          <>
            <Flex flexDirection="column" gap={BEACON_KEY_METRIC_CARD_SPACING}>
              {/* Review Sentiment */}
              <SentimentDonutAndColumnCharts />
              {/* Weekly Review Volume by Sentiment */}
              <SentimentWeeklyReviewVolumeStackedChart />
              {/* Cumulative Sentiment by TOpic */}
              <SentimentByTopicColumnChart />
              {/* Keyword COunt in CUmulative Positive Reviews */}
              <KeywordCountBySentimentTypeColumnChart reviewType="positive" />
              {/* Keyword Count in CUmulative Negative Reviews */}
              <KeywordCountBySentimentTypeColumnChart reviewType="negative" />
              {/* CUmulative Sentiment by Category */}
              {!isCategoryEntity && !isSubcategoryEntity && !isProductEntity && (
                <SentimentByTaxonomyStackedColumnChart taxonomyType="category" />
              )}
              {/* Cumulative Sentiment by Subcategory */}
              {!isSubcategoryEntity && !isProductEntity && (
                <SentimentByTaxonomyStackedColumnChart taxonomyType="subcategory" />
              )}

              {/* Key Metrics by Review */}
              <ReviewSummaryProductGrid disableGroupBy={isProductEntity} metric="sentiment" tableComponent="review" />
            </Flex>
          </>
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default ReviewSentimentPage;
